"use client";

import { useCallback, useEffect, useState } from "react";

/**
 * Toggle browser fullscreen for the whole mHive app (the document root) and
 * keep a reactive `isFullscreen` flag in sync via the `fullscreenchange` event.
 */
export function useFullscreen() {
  const [isFullscreen, setIsFullscreen] = useState(false);

  useEffect(() => {
    const onChange = () => setIsFullscreen(Boolean(document.fullscreenElement));
    document.addEventListener("fullscreenchange", onChange);
    onChange();
    return () => document.removeEventListener("fullscreenchange", onChange);
  }, []);

  const toggle = useCallback(() => {
    if (document.fullscreenElement) {
      void document.exitFullscreen();
    } else {
      void document.documentElement?.requestFullscreen();
    }
  }, []);

  return { isFullscreen, toggle };
}
